"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var useScroll = function useScroll(props) {
  var _a = props || {},
    element = _a.element,
    _b = _a.behavior,
    behavior = _b === void 0 ? 'smooth' : _b;
  var scroll = (0, _react.useCallback)(function (params) {
    var _a = params.position,
      position = _a === void 0 ? {} : _a,
      _b = params.direction,
      direction = _b === void 0 ? 'bottom' : _b;
    var options = __assign(__assign({}, position), {
      behavior: behavior
    });
    var scrollElement = element || window;
    var calculateElement = element || document.documentElement;
    if (!position.top && !position.left) {
      switch (direction) {
        case 'top':
          options.top = 0;
          break;
        case 'right':
          options.left = calculateElement.scrollWidth;
          break;
        case 'bottom':
          options.top = calculateElement.scrollHeight;
          break;
        case 'left':
          options.left = 0;
          break;
      }
    }
    scrollElement.scrollTo(options);
  }, [behavior, element]);
  return scroll;
};
var _default = useScroll;
exports.default = _default;